import { FC } from 'react';

type Props = {
  checked?: boolean;
  title: string;
  onChange: (val: boolean) => void;
};

export const Switcher: FC<Props> = ({ checked, title, onChange }) => {
  return (
    <div className="d-flex flex-nowrap align-items-center">
      <div className="form-check form-check-solid form-switch fv-row">
        <input
          className="form-check-input w-45px h-30px"
          type="checkbox"
          checked={checked ?? false}
          onChange={(e) => onChange(e.target.checked)}
        />
      </div>
      <label className="form-label ms-2 mt-1 fs-6">{title}</label>
    </div>
  );
};
